export const isFotoInicio = (nsmp) => nsmp.fotoInicio != null && nsmp.fotoInicio;

export const isFotoFim = (nsmp) => nsmp.fotoFim != null && nsmp.fotoFim;

export const isAnaliseRisco = (nsmp) => nsmp.analiseRisco != null && nsmp.analiseRisco;

export const isFotoRegistro = (nsmp) => nsmp.fotoRegistro != null && nsmp.fotoRegistro;

export const isAnexoNsmp = (nsmp) =>
  isFotoInicio(nsmp) || isFotoFim(nsmp) || isAnaliseRisco(nsmp) || isFotoRegistro(nsmp);

export const isFotoRow = (nsmp) =>
  isFotoInicio(nsmp) || isFotoFim(nsmp) || isFotoRegistro(nsmp);

export const isServiceRow = (nsmp) =>
  !isFotoInicio(nsmp) && !isFotoFim(nsmp) && !isAnaliseRisco(nsmp) && !isFotoRegistro(nsmp);

export const isAnaliseRiscoOrFotoRegistro = (nsmp) =>
  isAnaliseRisco(nsmp) || isFotoRegistro(nsmp);

export const USO_MUTUO_ROW_KIND = {
  POSTE: 'poste',
  ENTREGA_SUCATA: 'entregaSucata',
  PESAGEM_SUCATA: 'pesagemSucata',
  ANALISE: 'analise',
  FOTO_REGISTRO: 'fotoRegistro',
};

export const isUsoMutuoPosteRow = (nsmp) => {
  if (!nsmp) return false;
  if (nsmp.tipoNsmp === 'ENTREGA_SUCATA' || nsmp.tipoNsmp === 'PESAGEM_SUCATA') return false;
  if (isAnaliseRisco(nsmp) || isFotoRegistro(nsmp)) return false;
  return nsmp.isServico === true || nsmp.isService === true || nsmp.isServico === 'true'
    || Boolean(nsmp.numeroPoste);
};

export const isUsoMutuoSucataRow = (nsmp) =>
  nsmp?.tipoNsmp === 'ENTREGA_SUCATA' || nsmp?.tipoNsmp === 'PESAGEM_SUCATA';

export const getUsoMutuoRowKind = (nsmp) => {
  if (!nsmp) return USO_MUTUO_ROW_KIND.POSTE;
  if (nsmp.tipoNsmp === 'ENTREGA_SUCATA') return USO_MUTUO_ROW_KIND.ENTREGA_SUCATA;
  if (nsmp.tipoNsmp === 'PESAGEM_SUCATA') return USO_MUTUO_ROW_KIND.PESAGEM_SUCATA;
  if (isAnaliseRisco(nsmp)) return USO_MUTUO_ROW_KIND.ANALISE;
  if (isFotoRegistro(nsmp)) return USO_MUTUO_ROW_KIND.FOTO_REGISTRO;
  return USO_MUTUO_ROW_KIND.POSTE;
};

export const isUsoMutuoServiceRow = (nsmp) => !isAnaliseRiscoOrFotoRegistro(nsmp);
